import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { AzureDevOpsWorkItemDto, FetchError, queryKeys, useAccessToken } from "src/http";

const useGetAzureDevOpsWorkItemCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getAzureDevOpsWorkItemCollection({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.azureDevOpsWorkItems.getAzureDevOpsWorkItemCollection>>): Promise<
    AzureDevOpsWorkItemDto[]
  > {
    const accessToken = await getAccessToken();
    const [, azureDevOpsWorkItemCollectionGuid] = queryKey;

    const response = await fetch(
      `${configuration.apiRootUrl}/azure-devops-work-item-collections/${azureDevOpsWorkItemCollectionGuid}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getAzureDevOpsWorkItemCollection };
};

const useGetAzureDevOpsWorkItemCollection = (azureDevOpsWorkItemCollectionGuid: string | null) => {
  const { getAzureDevOpsWorkItemCollection } = useGetAzureDevOpsWorkItemCollectionRequest();

  return useQuery({
    queryKey: queryKeys.azureDevOpsWorkItems.getAzureDevOpsWorkItemCollection(azureDevOpsWorkItemCollectionGuid),
    queryFn: getAzureDevOpsWorkItemCollection,
    enabled: azureDevOpsWorkItemCollectionGuid != null,
  });
};

export { useGetAzureDevOpsWorkItemCollection };
